<template>
  <div class="ota-page">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
      <div class="inline-block">
        <span class="w-90 inline-block align-r m-r-8">平台名称：</span>
        <el-input v-model="filters.search.platformName" class="w-150" placeholder="请输入" ></el-input>
      </div>
      <div class="inline-block">
        <span class="w-110 inline-block align-r m-r-8">单位经营名称：</span>
        <el-input v-model="filters.search.companyRunName" class="w-150" placeholder="请输入" ></el-input>
      </div>
      <el-button class="submit-btn m-l-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>

    <div class="page-operate-block">
      <span class="tit">OTA信息</span>
      <div>
        <el-button
          class="operate-btn"
          @click="showModal('add')"
          >新增</el-button
        >
        <el-button
          class="operate-btn"
          :disabled="options.selection.length != 1"
          @click="showModal('edit')"
          >编辑</el-button
        >
        <el-button
          class="operate-btn"
          :disabled="options.selection.length === 0"
          @click="handleDelete"
          >删除</el-button
        >
        <!-- <el-button
          v-permission="'add'"
          class="operate-btn"
          @click="showModal('add')"
          :disabled="!(this.options.selection.length === 1 && !this.options.selection[0].roomId)"
          >新增</el-button
        >
        <el-button
          v-permission="'update'"
          class="operate-btn"
          @click="showModal('edit')"
          >编辑</el-button
        >
        <el-button
          v-permission="'delete'"
          class="operate-btn"
          @click="showBindDialog('virtual')"
          >删除</el-button
        > -->
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      ></r-table>
    </div>

    <RModal
      title="新增"
      top="3vh"
      :show="detailModal"
      :closeOnClick="false"
      width="800px"
      @change="detailModal = false"
      @close="detailModal = false"
    >
      <template #content>
        <EditView :show="detailModal" :type="modalType" :detail="modalData" @success="modalSuccess" />
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal"
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
import EditView from './editView.vue'

const EQUIPMENT_TYPE = 103; // 设备类型：门锁

export default {
  name: "equipDoorlock",
  mixins: [tableMix],
  components: { RModal, RTable, EditView },
  data() {
    return {
      curStore: {},

      deviceType: EQUIPMENT_TYPE,
      modalType: 'add',
      modalData: {},

      // =================================================== 列表 table
      tableVarity: 'ota-table',
      tableColumn: [],
      tableData: [],
      detailModal: false,
      detailData: {},
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      searchKey: 'roomName',
      // 查询参数
      filters: {
        search: {
          platformName: "",
          companyRunName: "",
        },
      },
    };
  },
  created() {
    this.initTableColumns();
    this.getQuery();
  },
  methods: {
    // 初始化自定义表头
    initTableColumns() {
      // 表头 visible：默认可见
      let columns = [
        { prop: "platformName", label: "平台名称", visible: true, minWidth: 140 },
        { prop: "platformCode", label: "平台单位编码", visible: true, minWidth: 100 },
        { prop: "companyRegName", label: "单位注册名称", visible: true, minWidth: 160 },
        { prop: "companyRunName", label: "单位经营名称", visible: true, minWidth: 160 },
        { prop: "companyPhone", label: "联系电话", visible: true, minWidth: 120 },
        { prop: "companyCreditCode", label: "社会信用代码", visible: true, minWidth: 170 },
        { prop: "platformContactName", label: "联系人", visible: true, minWidth: 100 },
        { prop: "platformContactPhone", label: "联系人电话", visible: true, minWidth: 120 },
        { prop: "platformContactCertCode", label: "联系人证件号码", visible: true, minWidth: 160 },
        { prop: "workAddrDetail", label: "单位办公地址", visible: true, minWidth: 250 },
      ];

      columns.forEach((item) => {
        // if (item.prop === "companyName") {
        //   item.render = (row, index, column) => {
        //     return <div>瑞为技术</div>;
        //   };
        // }
      });

      this.tableColumn = columns;
    },
    // 显示日志详情
    handleShowDetail(row) {
      this.$emit("change-view", row);
    },
    // 获取查询参数
    getQueryParams() {
      let searches = {};
      for (let name in this.filters.search) {
        if (this.filters.search[name] === "") {
          continue;
        }
        let searchParam = this.filters.search[name];
        searches[name] =
          typeof searchParam === "string" ? searchParam.trim() : searchParam;
      }
      if (searches.searchVal) {
        searches[this.searchKey] = searches.searchVal
      }
      delete searches.searchVal

      return {
        ...searches,
        // storeId: this.curStore.id || '',
        // deviceType: this.deviceType,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      };
    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true;
      let params = this.getQueryParams();

      let url = "OTA.GET_LIST";
      this.fetchData({
        url,
        method: "get",
        params,
      })
        .then((res) => {
          this.options.loading = false;

          if (!res || !res.data) {
            this.tableData = [];
            this.pagination.total = 0;
          } else {
            this.tableData = res.data || [];
            this.pagination.total = res.count;
          }
        })
        .catch((err) => {
          console.log(err, "=== OTA列表获取失败");
        })
        .finally(() => {
          this.options.loading = false;
        });
    },
    // 弹框操作成功
    modalSuccess() {
      this.detailModal = false
      this.pagination.pageIndex = 1
      this.getQuery()
    },
    // 处理打开弹框
    showModal(type) {
      this.modalType = type
      this.detailModal = true
      if (type === 'edit') {
        this.modalData = this.options.selection[0]
      } else {
        this.modalData = {}
      }
    },
    // 处理删除
    handleDelete() {
      let url = 'OTA.POST_DELETE_BY_IDS'
      let params = this.options.selection.map(item => item.id)

      this.$confirm('确定删除当前选中的（' + this.options.selection.length + '条记录）信息吗？', { type: 'warning' }).then(() => {
        this.fetchData({url, method: 'post', params, flag: true, headers: { "Content-Type": "application/json" }}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg || '删除成功！')
            this.pagination.pageIndex = 1
            this.getQuery()
          } else {
            this.$message.error(res.msg || '删除失败！')
          }
        }).catch((err) => {
          this.$message.error(err || '删除失败！')
        })
      }).catch(() => false)
    },
    // 操作成功，刷新列表
    submitSuccess() {
      this.detailModal = false;
      this.getDataList();
    },
    // 关闭弹框
    closeModel() {
      this.detailModal = false;
    },
  },
};
</script>
